import React from "react";
import { makeStyles, Theme } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import { Trad } from "../../components/";

interface IMainContentProps {
    Icon: React.ElementType;
    Title: string;
}

const useStyles = makeStyles(({ palette, spacing }: Theme) => ({
    pageTitle: {
        paddingTop: spacing(4),
        paddingBottom: spacing(1),
        paddingRight: "1rem",
        paddingLeft: "1rem",
        display: "flex",
        alignItems: "center",
        color: palette.primary.main
    },
    pageIcon: {
        marginRight: spacing(2)
    }
}));

export const _PageTitle: React.FC<IMainContentProps> = props => {
    const classes = useStyles();
    const { Icon, Title } = props;

    return (
        <Box className={classes.pageTitle}>
            <Box display="flex" flexGrow={1} alignItems="center">
                <Icon fontSize="large" className={classes.pageIcon} />
                <Typography variant="h6" component="h1">
                    {Trad.Trad(Title)}
                </Typography>
            </Box>
            {props.children}
        </Box>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/layout/PageTitle.tsx